import api from './Api'

const route = '/comodato'

export default {
  getVariables: () => api().get(`${route}/variables`),
  getClauses: (dealerId) => api().get(`${route}/clauses/${dealerId}`),
  saveClauses: (dealerId, payload) => api().put(`${route}/clauses/${dealerId}`, payload, {
    headers: { 'Content-Type': 'application/json' }
  }),
  restoreClause: (dealerId, clauseId) => api().post(`${route}/clauses/${dealerId}/restore/${clauseId}`),
  getPreview: (dealerId) => api().get(`${route}/preview/${dealerId}`)
}
